import { useQuery } from 'react-query'
import hooks from '../../../hooks'

const useFacilitatorSurveys = () => {
    const cacheKeys = hooks.useCacheKeys()
    const { api, endpoints, url, time } = hooks.useApi()
    const { id: userId } = hooks.useCurrentUser()

    const { data, isLoading } = useQuery(
        [cacheKeys.FACILITATOR_SURVEYS, userId],
        () => api.get(url(endpoints.userFacilitatorSurveys, {userId})),
        {
            staleTime: time.HOUR,
            enabled: Boolean(userId)
        }
    )

    const facilitatorSurveys = data || []

    return {
        facilitatorSurveys,
        isLoadingFacilitatorSurveys: isLoading,
    }
}

export default useFacilitatorSurveys
